
export default {
  name: 'MinimalLayout',
}
